import $ from 'jquery'

export default {
	name: 'edit-medicament',
	components: {},
	props: [],
	data() {
		return {
			loading: false,
			loading_attribut: true,
			libelle: '',
			minimum: 0,
			optimale: 0,
			prix: 0,
			attributs: [],
			attributs_articles: []
			//type_is_selected: false
		}
	},
	computed: {
		//Chargement de l'article
		medicament() {
			return this.$store.getters['article']
		},

		type() {
			return this.$store.getters['type']
		},
		//Chargement des attributs de l'articles
		/*attribut() {
			return JSON.parse(this.article.attribut)
		},*/

		//Type article
		type_articles() {
			return this.$store.getters['types']
		},
	},
	mounted() {

		setTimeout(() => {
			$('.p-content').fadeIn();
		}, 1000);

		//Initialisation du formulaire de médicament
		const data = {
            month: "",
            one_date: this.setDates().today_date,
            from_date: "",
            to_date: "",
            article_id: this.$route.params.id
        }
		this.changeType(data, 1);


	},
	methods: {
		async changeType(data, id) {
			this.attributs = []

			await this.$store.dispatch("getArticle", data)

			await this.$store.dispatch("getType", id).then(() => {
				this.setAttributsArticles()
				this.getAttributs()
			})
			this.loading_attribut = false
		},

		setAttributsArticles() {
			let attrs = this.type['attribut_articles']

			attrs.forEach(attr => {
				let occurences = []
				attr.occurence.forEach(occ => {
					occurences.push(occ.libelle)
				})

				const tmp_attr = {
					id: attr.id,
					libelle: attr.libelle,
					type_attribut_id: attr.type_attribut_id,
					occurence: occurences
				}
				this.attributs_articles.push(tmp_attr)
			});
		},

		/**
		 * Récupère la forme d'un médicament à partir de l'abréviation
		 * 
		 */
		getForme(abreviation) {
			let forme = ''
			if (abreviation != null && typeof abreviation === 'string') {
				abreviation = abreviation.trim()
			}
			
			switch (abreviation) {
				case 'Aéro-Do':
					forme = 'Aérosol-Doseur'
					break
				case 'Amp Buv':
					forme = 'Ampoule buvable'
					break
				case 'CP':
					forme = 'Comprimés'
					break
				case 'CP EFF':
					forme = 'Comprimés Effervescent'
					break 
				case 'CP Eff':
					forme = 'Comprimés Effervescent'
					break 
				case 'INJ':
					forme = 'Injectable'
					break 
				case 'Inj':
					forme = 'Injectable'
					break 
				case 'Ovu':
					forme = 'Ovule'
					break
				case 'Oph':
					forme = 'Ophtalmique'
					break 
				case 'Sch Péd':
					forme = 'Sachet Pédiatrique'
					break 
				case 'Solu':
					forme = 'Solution'
					break 
				case 'Sp':
					forme = 'Sirop'
					break 
				case 'Susp':
					forme = 'Suspension'
					break 
				case 'Suppo':
					forme = 'Suppositoire'
					break 
				case 'Voie rectale':
					forme = 'Voie Rectale'
					break
				default:
					forme = abreviation
					break
			}

			return forme
		},

		getAttributs() {
			for (let i = 0; i < this.type['attribut_articles'].length; i++) {
				let valeur = ''
				if (this.type['attribut_articles'][i].libelle == 'Unité Dosage') {
					valeur = this.medicament.attribut[this.type['attribut_articles'][i].libelle]
					
					if (valeur != null) {
						valeur = valeur.toLowerCase()
					}
					
				} else if (this.type['attribut_articles'][i].libelle == 'Forme') {
					valeur = this.getForme(this.medicament.attribut[this.type['attribut_articles'][i].libelle])
				} else {
					valeur = this.medicament.attribut[this.type['attribut_articles'][i].libelle]
				} 
				this.attributs.push(
					{
						valeur: valeur,
						libelle: this.type['attribut_articles'][i].libelle,
						attribut: this.type['attribut_articles'][i].id
					});

				let occurence_len = this.type['attribut_articles'][i].occurence.length;

				if (occurence_len > 0) {
					for (let j = 0; j < occurence_len; j++) {
						// Caster les unités dosage en minuscule
						if (this.type['attribut_articles'][i].libelle == 'Forme') {
							let forme = this.type['attribut_articles'][i].occurence[j].libelle
							if (forme != null && typeof forme === 'string') {
								this.type['attribut_articles'][i].occurence[j].libelle = forme.trim()
							}
							
						}
					}
				}
			}
		},

		async submitForm() {

			const isValid = await this.$refs.observer.validate();

			if (isValid) {
				this.loading = true;
				const id = this.$route.params.id

				const data = {
					libelle: this.medicament.libelle,
					prix: (this.medicament.prix != '')?this.medicament.prix:0,
					minimum: (this.medicament.minimum != '')?this.medicament.minimum:0,
					optimale: (this.medicament.optimale != '')?this.medicament.optimale:0,
					type_article: 1,
					attribut: this.attributs
				}


				this.$store.dispatch("editArticle", { id, data }).then(
					response => {
						if (response) {
							this.loading = false;
							this.$router.push({ path: `/medicaments/view/` + id })
						} else {
							this.loading = false;
						}
					}
				);
			}

		},
	}
}


